import { useParams } from 'react-router-dom'
import SchedaLavoroV2 from './SchedaLavoroV2'
import SchedaLavoroV3 from './SchedaLavoroV3'

/**
 * Quale pagina serve /schede-lavoro/:id.
 *
 * Dal 04/09/2026 il dettaglio predefinito e' la V3, ma lo stesso percorso
 * ospita anche la CREAZIONE: `/schede-lavoro/new`, dove "new" non e' un id ma
 * una parola chiave che la V2 riconosce (`const isNew = id === 'new'`) per
 * mostrare il form di accettazione. La V3 quel flusso non ce l'ha.
 *
 * La scelta si fa qui e non con una rotta statica `/schede-lavoro/new`: quella
 * rotta non dichiara `:id`, quindi `useParams()` non lo restituisce, `isNew`
 * resta falso e la V2 cerca una scheda con id `NaN` — che e' esattamente il
 * "Scheda non trovata" del collaudo del 04/09.
 */
export default function DettaglioScheda() {
  const { id } = useParams<{ id: string }>()
  return id === 'new' ? <SchedaLavoroV2 /> : <SchedaLavoroV3 />
}
